window.dbs = window.dbs || {}
dbs.google = dbs.google || {}

dbs.google.placesService = function (google) {
  const self = this

  // See: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesService
  const PlacesService = new google.maps.places.PlacesService(document.createElement('div'))

  /**
   * Retrieves details about the place identified by the given `placeId`.
   * See: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlacesService.getDetails
   * @function
   * @param {object} request - request: PlaceSearchRequest. See: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceDetailsRequest
   * @param {function} callback - callback: function(PlaceResult optional, PlacesServiceStatus): void
   */
  self.getDetails = function (request, callback) {
    PlacesService.getDetails(request, (PlaceResult, PlacesServiceStatus) => callback(PlaceResult, PlacesServiceStatus))
  }
}
